export class onClose {
  cancel: boolean = false;
}
